module.exports = __webpack_public_path__ + "img/mypage-active.a567b401.png";